import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onShare"],
  _excluded2 = ["onShare", "onOpenChange", "render"];
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import styled from 'academy-common-lib/utils/Styling';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SocialShareList, useSocialShareData } from '..';
import { useState } from 'react';
import { CardMenu, CardMenuOptions } from '../../cardMenu';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RowSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "SocialShareMenuOption__RowSpinner",
  componentId: "rvp2aj-0"
})(["position:absolute;right:10px;"]);
export const MobileSocialShareMenuOption = _ref => {
  let {
      onShare
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SocialShareList, Object.assign({
    onClick: onShare,
    renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.share"
        })
      }), content]
    }),
    renderRow: content => /*#__PURE__*/_jsx(MenuRow, {
      children: content
    })
  }, props));
};
export const SocialShareMenuOption = _ref2 => {
  let {
      onShare,
      onOpenChange,
      render = (handleOpen, isLoading) => /*#__PURE__*/_jsx(UISideNavItem, {
        iconRight: isLoading ? /*#__PURE__*/_jsx(RowSpinner, {
          size: "extra-small"
        }) : 'right',
        onMouseEnter: handleOpen,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.share"
        })
      })
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoading
  } = useSocialShareData(props);
  const handleOnOpenChange = newOpenState => {
    setIsOpen(newOpenState);
    if (onOpenChange) onOpenChange(newOpenState);
  };
  const handleOnShare = type => {
    if (onShare) onShare(type);
    handleOnOpenChange(false);
  };
  const handleOpen = () => handleOnOpenChange(true);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      body: /*#__PURE__*/_jsx(SocialShareList, Object.assign({
        onClick: handleOnShare,
        renderList: content => /*#__PURE__*/_jsx(CardMenuOptions, {
          children: content
        }),
        renderRow: button => /*#__PURE__*/_jsx(UISideNavItem, {
          role: "navigation-item",
          title: button
        })
      }, props))
    },
    onOpenChange: e => handleOnOpenChange(e.target.value),
    open: isOpen,
    placement: "right bottom",
    children: render(handleOpen, isLoading)
  });
};
export default SocialShareMenuOption;